import type { ReactElement } from 'react'
import { useState } from 'react'

import {
  TooltipFilledIcon,
  TooltipOutlineIcon,
} from '@twistopayments/design-system/icons/inline'

import type { ArticleTooltipComponent } from '@twisto/api-cms'

import { AccessibleDiv } from '../accessible-div'

import * as styles from './tooltip.styles'

type TooltipProps = {
  content?: ReactElement
  url?: string
}

export const Tooltip = ({
  content,
  variant,
  id,
  url,
}: ArticleTooltipComponent & TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false)

  const Icon = variant === 'filled' ? TooltipFilledIcon : TooltipOutlineIcon

  return (
    <AccessibleDiv
      css={styles.tooltipContainer}
      id={id?.toString() || ''}
      role="link"
      onActivate={() => url && window.open(url, '_blank')}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      <div className="content" css={styles.tooltipContent}>
        {isVisible && content}
      </div>
      <Icon css={styles.icon} size="24" />
    </AccessibleDiv>
  )
}
